module.exports = __webpack_public_path__ + "static/media/icon_37.f1cea45d.svg";